/* ═══ EL VISOR DE LA FICHA — foto principal + tira de miniaturas ═════════════
   Marisa, mirando la Planner: «sigo viendo la imagen de la planner ENORME, no me
   gusta, o que se vea completa en la pantalla» · «me encanta esto: la imagen
   mucho más pequeña y las imágenes al lado».

   Antes la galería eran ocho figuras apiladas en dos columnas: se veía una foto
   por pantalla y había que bajar para saber que existían las demás. Medido a
   1440×900: la primera figura arrancaba en 190 px y medía 865, o sea que ni la
   portada entera cabía en la pantalla.

   Ahora es lo que hace cualquier tienda: UNA foto a la vista y las demás en una
   tira al lado, a un toque. El contenido de abajo no se toca — a ella le gusta.

   🔴 POR QUÉ SE MONTA DESDE AQUÍ Y NO EN EL HTML: las cinco fichas las genera
   `_partes/fichas.py` y su cabecera avisa de que el siguiente pase sobrescribe
   lo que se edite a mano. Montarlo aquí sirve a las cinco a la vez y sobrevive
   a la próxima generación.

   🔴 Y EL CSS DEL VISOR VIVE BAJO `@media (scripting: enabled)`: si este archivo
   no llega, la galería se queda como estaba —ocho figuras apiladas, todas
   visibles— en vez de dejar siete fotos escondidas detrás de unas miniaturas
   que nadie va a pintar. */
(() => {
  const gal = document.querySelector('.gal');
  if (!gal) return;

  const figuras = [...gal.querySelectorAll(':scope > figure')];
  if (figuras.length < 2) return;          /* con una sola foto no hay tira */

  /* El pie de cada figura es el nombre de la toma («La portada», «El semanal»):
     sirve de etiqueta accesible del botón, que si no sería «imagen 3 de 8». */
  const nombre = f => (f.querySelector('figcaption')?.textContent || '').trim();

  const tira = document.createElement('ul');
  tira.className = 'gal-tiras';
  tira.setAttribute('aria-label', 'Fotos del producto');

  const botones = figuras.map((f, i) => {
    const li  = document.createElement('li');
    const bt  = document.createElement('button');
    bt.type = 'button';
    bt.setAttribute('aria-pressed', String(i === 0));
    bt.title = nombre(f);
    /* La miniatura NO es una copia del `<img>` grande: se clona el nodo para
       heredar `srcset` y `sizes` tal cual, y se le quita el `data-hero-img`
       —ese atributo es el ancla que usa `ficha.js` para repintar la foto al
       cambiar de color, y dos nodos con la misma marca serían dos dueños. */
    const im = f.querySelector('img').cloneNode(true);
    im.removeAttribute('data-hero-img');
    im.removeAttribute('fetchpriority');
    im.loading = 'lazy';
    im.alt = '';
    bt.append(im);
    const sr = document.createElement('span');
    sr.className = 'sr';
    sr.textContent = nombre(f) || `Foto ${i + 1}`;
    bt.append(sr);
    li.append(bt);
    tira.append(li);
    return bt;
  });

  figuras.forEach((f, i) => f.classList.toggle('viva', i === 0));
  gal.prepend(tira);

  function ver(i) {
    figuras.forEach((f, k) => f.classList.toggle('viva', k === i));
    botones.forEach((b, k) => b.setAttribute('aria-pressed', String(k === i)));
  }

  /* ── LAS FLECHAS, A LA VISTA ───────────────────────────────────────────────
     🔴 ESTO ESTABA MAL PENSADO Y LO CAZÓ paco: «no funcionan las flechitas».
     El teclado SÍ recorría la tira, pero sólo con el foco DENTRO de ella, o sea
     después de haber hecho clic en una miniatura. Quien llega a la ficha y pulsa
     una flecha no cambia de foto: hace scroll. Una función que hay que descubrir
     para poder usarla no existe.
     Se resuelve enseñándolas: dos botones sobre la foto, que es donde el ojo ya
     está. En reposo se retiran para no competir con el producto y aparecen al
     acercar el ratón —y siempre que reciben el foco, que si no volveríamos al
     mismo problema con el teclado. */
  const flecha = (dir, etiqueta) => {
    const bt = document.createElement('button');
    bt.type = 'button';
    bt.className = 'gal-flecha gal-' + dir;
    bt.setAttribute('aria-label', etiqueta);
    bt.innerHTML = '<svg class="ico" aria-hidden="true" viewBox="0 0 24 24">' +
      '<path d="M15 5 8 12l7 7" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    bt.addEventListener('click', () => mueve(dir === 'antes' ? -1 : 1));
    return bt;
  };
  const antes = flecha('antes', 'Foto anterior');
  const desp  = flecha('desp',  'Foto siguiente');
  gal.append(antes, desp);

  /* 🔴 LAS FOTOS OCULTAS NO SE DESCARGAN HASTA QUE SE PIDEN. Están en
     `display:none` y con `loading="lazy"`, así que el navegador se las guarda:
     el primer toque en una miniatura enseñaba el panel vacío mientras bajaba la
     foto. Es el único momento en que este visor se sentiría peor que la galería
     apilada, donde todo bajaba de camino.
     Se piden en cuanto la página está quieta —`requestIdleCallback`, para no
     competir con lo que sí se está viendo— y a partir de ahí cambiar de foto es
     instantáneo. */
  const precarga = () => figuras.slice(1).forEach(f => {
    const im = f.querySelector('img');
    if (!im) return;
    const p = new Image();
    if (im.srcset) p.srcset = im.srcset;
    if (im.sizes)  p.sizes  = im.sizes;
    p.src = im.currentSrc || im.src;
  });
  ('requestIdleCallback' in window)
    ? requestIdleCallback(precarga, { timeout: 2500 })
    : addEventListener('load', () => setTimeout(precarga, 400), { once: true });

  tira.addEventListener('click', e => {
    const b = e.target.closest('button');
    if (b) ver(botones.indexOf(b));
  });

  /* ── AL CAMBIAR DE COLOR, VOLVER A LA PORTADA ───────────────────────────
     🔴 EL PROBLEMA, DICHO POR paco: «si tengo otra foto en el carrusel y luego
     cambio de color, no me doy cuenta». Y es literal, no una impresión: las
     muestras repintan la figura 0 —la portada— pero si estás mirando «El
     semanal» esa figura está en `display:none`. El color cambia de verdad, en
     un sitio que nadie está viendo. Elegir algo y que la pantalla no conteste
     es lo contrario de premium.

     La respuesta NO es una animación nueva. La galería ya tiene la suya
     —`gal-entra`: desvanece, entra desde 0.97 y suelta 3 px de desenfoque en
     180 ms— y sólo hacía falta que este momento la disparara. Reusar el gesto
     que el visor ya hace al tocar una miniatura es lo que hace que se lea a
     sistema y no a parche.

     🔴 Y EL ORDEN IMPORTA: primero llega la foto, DESPUÉS se enseña. Si
     volviéramos a la portada al instante del clic, se vería un pestañeo del
     color viejo antes del nuevo —`ficha.js` sustituye el nodo cuando la imagen
     ya está decodificada, no antes—. Por eso el disparo cuelga del observador
     que ya vigila el panel: cuando la foto ES la nueva, la portada entra. Se
     lee como una sola cosa: «aquí está tu planner, en terracota».

     El `setTimeout` es el camino de respaldo para el caso en que la foto no
     cambie —tocar la muestra que ya estaba activa—: ahí no hay mutación que
     escuchar y aun así hay que llevar a quien mira a donde se ve el color. */
  const enPortada = () => figuras[0].classList.contains('viva');
  /* En teléfono la tira se apaga y la galería es un carrusel con scroll-snap:
     ahí «volver a la portada» no es encender una figura, es desplazar el
     carril. Se detecta por la tira, no por un ancho a mano: si mañana cambia
     el punto de corte del CSS, esto sigue diciendo la verdad. */
  const enModoCarrusel = () => getComputedStyle(tira).display === 'none';
  const suave = !matchMedia('(prefers-reduced-motion: reduce)').matches;

  function volverAPortada() {
    if (enModoCarrusel()) {
      gal.scrollTo({ left: 0, behavior: suave ? 'smooth' : 'auto' });
    } else if (!enPortada()) {
      ver(0);
    }
  }

  let pendiente = 0;
  document.querySelectorAll('.tonos button').forEach(b =>
    b.addEventListener('click', () => {
      pendiente = setTimeout(() => { pendiente = 0; volverAPortada(); }, 320);
    }));

  /* 🔴 LA MINIATURA DE LA PORTADA TIENE QUE SEGUIR AL COLOR. `ficha.js` repinta
     la foto grande al elegir Cobalto o Lima y la miniatura se quedaba en
     orquídea: la tira decía un color y el visor otro, sobre el mismo producto.

     Y aquí hubo una trampa que sólo se ve midiendo. El primer intento observaba
     los atributos del `<img>`… y no saltaba nunca. Resulta que `ficha.js` no le
     cambia el `src`: SUSTITUYE EL NODO ENTERO —es la manera de que la foto no
     parpadee en blanco mientras baja la nueva—, así que mi observador se quedó
     mirando un `<img>` ya desconectado del documento. Comprobado: el nodo
     guardado antes del clic devolvía `isConnected: false`.
     Por eso se observa el PANEL y se vuelve a buscar la foto cada vez. */
  const panel = gal.querySelector('.grande .obj') || gal.querySelector('.grande');
  const mini  = botones[0]?.querySelector('img');
  if (panel && mini) {
    const sigue = () => {
      const h = panel.querySelector('[data-hero-img]') || panel.querySelector('img');
      if (!h) return;
      mini.src = h.getAttribute('src');
      if (h.hasAttribute('srcset')) mini.srcset = h.getAttribute('srcset');
      /* La foto nueva ya está en el panel: éste es el fotograma en el que
         enseñarla. Se adelanta al respaldo y se cancela para no hacerlo dos
         veces. */
      if (pendiente) { clearTimeout(pendiente); pendiente = 0; volverAPortada(); }
    };
    new MutationObserver(sigue).observe(panel,
      { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  }

  /* Da la vuelta en los extremos en vez de bloquearse: con ocho fotos y una
     tira que ya dice en cuál vas, un botón que deja de responder se lee a
     roto antes que a «se acabó». */
  function mueve(paso) {
    const i = figuras.findIndex(f => f.classList.contains('viva'));
    ver((i + paso + figuras.length) % figuras.length);
  }

  /* El teclado escucha en TODA la galería, no sólo en la tira: si sólo
     respondiera con el foco en una miniatura, volveríamos al problema que
     acabamos de arreglar. Dentro de la tira además mueve el foco, que es lo que
     un grupo de botones de una sola elección tiene que hacer. */
  gal.addEventListener('keydown', e => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' &&
        e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const paso = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
    const i = botones.indexOf(document.activeElement);
    if (i >= 0) {
      const j = (i + paso + botones.length) % botones.length;
      botones[j].focus();
      ver(j);
    } else {
      mueve(paso);
    }
  });
})();
